import { Box, Typography } from '@material-ui/core';
import { PrettoSlider } from '@room-match/shared-ui-components';
import { base64ToBlob } from 'base64-blob';
import 'cropperjs/dist/cropper.css';
import React, { Fragment, useState } from 'react';
import { Cropper } from 'react-cropper';
import useWindowDimensions from 'shared/hooks/useWindowDimenstion';
import { IOutput } from 'shared/interfaces/IProfile';
import { useStyles } from './ProfileImageCropper.styles';

const standardHeightPixel = 1500;
const standardWidthPixel = 1125;
const CROP_BOX_HEIGHT = 485;
const portraitAR = 472 / 648; //1200

type Props = {
  src: string;
  cropper: any;
  setCropper: (instance: any) => void;
  handleCrop: (imageData: IOutput) => void;
  addFamily?: boolean;
};

const ProfileImageCropper: React.FC<Props> = ({ src, cropper, setCropper, handleCrop, addFamily }) => {
  const classes = useStyles();
  const [minZoomRatio, setMinZoomRatio] = useState(0);
  const [maxZoomRatio, setMaxZoomRatio] = useState(1);
  const [imageData, setImageData] = useState<HTMLImageElement | undefined>(undefined);
  const { width } = useWindowDimensions();
  const [sliderDefaultValue, setSliderDefaultValue] = useState<number>(0);

  const handleSliderChange = (event: any, newValue: number | number[]) => {
    const valueNumber = newValue as number;
    setSliderDefaultValue(valueNumber);
    if (valueNumber > 0) {
      cropper.zoomTo(valueNumber);
    } else {
      cropper.zoomTo(0);
    }

    cropper.setCropBoxData({ height: CROP_BOX_HEIGHT });
  };

  const updateImageData = async (cropper: any) => {
    const cropData = cropper?.getCroppedCanvas()?.toDataURL('image/jpeg', 0.9);

    const convertedFile = await base64ToBlob(cropData);

    const i: HTMLImageElement = new Image();

    i.onload = function () {
      const fileSize = convertedFile.size;
      const finalFile: IOutput = {
        attachment: convertedFile,
        file_name: new Date().getTime().toString(),
        file_width: i.width.toString(),
        file_height: i.height.toString(),
        file_type: 'image',
        file_size: fileSize.toString(),
        tag_list: '',
      };

      handleCrop(finalFile);
    };

    i.src = cropData;
  };

  const handleImageReady = (e: Cropper.ReadyEvent<HTMLImageElement>) => {
    const imageData = e.currentTarget.cropper.getImageData();

    const minSliderZoom = imageData.width / imageData.naturalWidth;
    const maxSliderZoom =
      Math.min.apply([imageData.naturalWidth / standardWidthPixel, imageData.naturalHeight / standardHeightPixel]) || 1;

    setMaxZoomRatio(maxSliderZoom);
    setMinZoomRatio(minSliderZoom);

    updateImageData(e.currentTarget.cropper);
  };

  const handleReset = () => {
    cropper.reset();
  };

  const handleFlip = () => {
    const cropperData = cropper.getData();
    cropper.scaleX(-cropperData.scaleX);
  };

  const handleRotateRight = () => {
    cropper.rotate(45);
    cropper.zoomTo(minZoomRatio);
    setSliderDefaultValue(0.2);
  };

  const handleRotateLeft = () => {
    cropper.rotate(-45);

    cropper.zoomTo(minZoomRatio);
    setSliderDefaultValue(0.2);
  };

  const handleMove = (e: any) => {
    updateImageData(e.target.cropper);
  };

  let timer: any = null;
  return (
    <Fragment>
      <Box
        className={classes.photoContainer}
        style={{ width: addFamily ? '100%' : 283, height: addFamily ? 269 : 400 }}
      >
        <Cropper
          style={{ width: addFamily ? '100%' : 283, height: addFamily ? 269 : 400 }}
          // aspectRatio={portraitAR}
          className={classes.cropperCls}
          zoomTo={0}
          preview=".img-preview"
          src={src}
          minCropBoxHeight={485}
          minCropBoxWidth={485}
          viewMode={3}
          guides={false}
          center={false}
          autoCrop={true}
          responsive={true}
          background={false}
          wheelZoomRatio={0.1}
          modal={true}
          cropBoxResizable={false}
          ready={handleImageReady}
          zoomable={true}
          dragMode="move"
          checkCrossOrigin={true}
          zoomOnWheel={false}
          // zoom={(event) => {
          //   event.currentTarget.cropper.setCropBoxData({ height: CROP_BOX_HEIGHT });
          //   handleMove(event);
          // }}
          zoom={(e) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
              handleMove(e);
            }, 100);
          }}
          onInitialized={(instance) => {
            setCropper(instance);
          }}
          cropend={handleMove}
          cropBoxMovable={false}
        />
      </Box>
      {src && width > 960 && (
        <Box className={classes.sliderContainer}>
          {!addFamily && <Typography variant="body2">Scale: </Typography>}
          <PrettoSlider
            min={minZoomRatio}
            step={0.0001}
            value={sliderDefaultValue}
            max={1}
            disabled={maxZoomRatio <= minZoomRatio || !src}
            onChange={handleSliderChange}
          />
        </Box>
      )}
    </Fragment>
  );
};

export default ProfileImageCropper;
